// extracted by mini-css-extract-plugin
module.exports = {"message-container":"paidPostAction_message-container__hZqky","label-and-tooltip":"paidPostAction_label-and-tooltip__1dB5a"};